/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const Container = styled(Box)(({theme}) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.semantic_dark?.surface?.surface1,
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  minWidth: '450px',
  maxWidth: '700px',
}));
